import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PagesTable} from './table/PagesTable'
import {PageEditModal} from './pages-edit-modal/PageEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {PageListHeader} from './header/PageListHeader'
import { ToastContainer } from 'react-toastify'

const PagesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
      <ToastContainer />
        <PageListHeader />
        <PagesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PageEditModal />}
    </>
  )
}

const PagesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PagesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PagesListWrapper}
